export default __webpack_public_path__ + "static/media/User-Error-Mobile.0a1eb466.svg";